import { DoorOpen } from 'lucide-react';
import RestaurantEmptyState from '../../shared/RestaurantEmptyState';

const DiningRoomEmpty = () => {
  return (
    <RestaurantEmptyState
      icon={DoorOpen}
      title="No hay salones registrados"
      description="Aún no existen salones para esta sucursal. Puede crear ambientes como Salón Principal, Terraza, Área VIP o cualquier otro espacio para organizar las mesas del restaurante."
      hint="Comience creando su primer salón."
    />
  );
};

export default DiningRoomEmpty;